import { Injectable } from '@angular/core';
import { AppConfigService } from '@dexio/common';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ReportService {

  constructor(private readonly configs: AppConfigService, private readonly http: HttpClient) { }
  
  getEmailList(projects: string[], roles: string[]) {
    var data = {
      projects: projects,
      roles: roles
    };
    return this.http
      .post(`${this.configs.get().apiUrl}/reports/email-list`, data);
  }
}
